const MESSAGE = {
    PUSHED_LEAD_IN_PROCESS: 'Transfer Contact to Differ Database is in Process please wait',
    PLEASE_SELECT_DATABASE: "Please Select a database",
    CANCEL_LEAD_COMMUNICATION: "Please cancel the scheduled communication before moving the Contacts to other database ",
    ALL: "All",
    ADD_USER: "Add User",
    ADD_ROLE: "Please proceed with adding role first",
    EDIT_USER: "Edit User",
    EDIT_ROLE: "Edit Role",
    ROLE_DETAILS: "Role Details",
    EXCLUDED_LIST: "Excluded List",
    SELECTED_LIST: "Selected List",
    SUBJECT: "Please enter subject",
    CONTACT_SELECTED: "Contact Selected",
    DOCUMENT_TITLE: "Please enter title",
    VIDEO_TITLE: "Please enter title",
    FAQ_QUESTION: "Please enter question",
    FAQ_ANSWER: "Please enter answer",
    ENABLE_AUTO_ALERT_EMAIL: "Please enable auto alert response email",
    ENABLE_AUTO_ALERT_SMS: "Please enable auto alert response sms",
    VIDEO_FILE: "Please select video",
    SELECT_ACTION: "Please select action",
    SELECT_CONTACT: "Please select contact",
    CHOOSE_TEMPLATE: "Please choose template",
    ROLE_TITLE: "Please enter role title",
    SELECT_MODULES: "Please select modules",
    SELECT_TIMEZONE: "Please select timezone",
    SMS_CONTENT: "Please Write Content For SMS",
    SCHEDULE_DATE: "Please select schedule date",
    SCHEDULE_TIME: "Please select schedule time",
    TEMPLATE_TITLE: "Please enter template title",
    ADDED_FOR: "Please select at least one option",
    SELECT_ONE_CONTACT: "Select only one contact",
    RECEIVER_CANNOT_EMPTY: "Receiver cannot be empty",
    TEMPLATE_CONTENT: "Please enter template content",
    TEMPLATE_CANNOT_EMPTY: "Template content cannot be empty",
    EMAIL_ADDRESS_DNE: "Email address does not exist",
    MOBILE_NUMBER_DNE: "User mobile number does not exist",
    BORROWER_MOBILE_NUMBER_DNE: "Contact mobile number does not exist",
    EDITOR_CANNOT_EMPTY: "Email editor cannot be empty",
    EMAIL_CONTENT_EMPTY: "Email content cannot be empty",
    SELECTED_SUB_MODULES: "Please select sub modules",
    SELECT_CONNECT_MODULE: "Please select dashboard module",
    SELECT_SUB_MODULE: "Please select  submodule",
    EMAIL_SENDING_ERROR: "Error Occured While Sending Email",
    UPLOAD_TEMP_ERROR: "Error Occured While Uploading Template",
    SCHEDULED_EMAIL_ERROR: "Error Occured While Scheduled Email",
    REDUCE_MESSAGE: "Please reduce message upto 2000 characters",
    CHARACTERS_LESS_THEN_250: "Characters should be less 250",
    CHARACTERS_LESS_THEN_30: "Characters should be less then 30",
    ADMIN_TEMPLATE_CANNOT_DELETE: "Admin template cannot be deleted",
    CANNOT_DELETE_ADMIN_TEMPLATE: "Admin template cannot be deleted",
    ERROR_WHILE_UPDATE_TEMP: "Error Occured While updating template",
    ERROR_WHILE_DELETE_TEMP: "Error Occured While deleting template",
    MOBILE_NUMBER_VALIDATION: "Please enter your 10 digit Mobile No ",
    PHONE_NUMBER_VALIDATION: "Please enter your 10 digit Phone No",
    FAX_NUMBER_VALIDATION: "Please enter your 10 digit Fax No",
    SMS_SENDING_ERROR: "Error Occured While Sending SMS. Please Try Again!",
    EMAIL_CONTENT_SIZE: "Email content size should not be greater than 5 MB",
    TEMPLATE_NAME_CANNOT_SAME: "Template name can not be same as admin template",
    SCHEDULE_EMAIL_DELETING_ERROR: "Error Occured While Deleting Schedule Email",
    SEQUENCE_CANCEL_ERROR: "Error Occured While Canceling Campaign",
    AUTO_ALERT_RESPONSE_EMAIL: "Please select auto alert response email template",
    AUTO_ALERT_RESPONSE_SMS: "Please select auto alert response sms template",
    SELECT_OPTION_FROM_DROPDOWN: "Please select an option from the dropdown only",
    AUTO_ALERT_RESPONSE_EMAIL_ENABLED:
        "Send automatic auto alert response email enabled",
    AUTO_ALERT_RESPONSE_EMAIL_DISABLED:
        "Send automatic auto alert response email Disabled",
    EMAIL_SCHEDULED_AHEAD_CURRENT_TIME:
        "Emails can only be scheduled ahead of current time",
    SMS_SCHEDULED_AHEAD_CURRENT_TIME:
        "SMS can only be scheduled ahead of current time",
    EMPTY_NOTES: "Notes content cannot be empty",
    NOTES_EMPTY: "Text can not be greater than 1000 characters",
    SELECT_CLIENT_PROFILE_MANDATORY:
        "Its mandatory to select client profile if the view is selected in client listing",
    DOCUMENT_TITLE: "Please enter title",
    VIDEO_TITLE: "Please enter title",
    FAQ_QUESTION: "Please enter question",
    FAQ_ANSWER: "Please enter answer",
    FILE: "Please select file",
    VIDEO_FILE: "Please select video",
    ADDED_FOR: "Please select at least one option",
    FEIN_VALIDATION: "Please enter your 5-16 digit fein ",
    DOMAIN_VALIDATION:
        "Please enter a valid URL. Protocol is required (http://, https://)",
    DOCUMENT_DOWNLOADED: "Document has been downloaded successfully",
    FILE_LARGE: "File size must be less than 1 mb",
    NUMBER_OF_CARDS: "Maximum of 3 cards can be saved",
    PRIMARY_CARD: "Already a primary card",
    ALREADY_PRIMARY: "Card already set as primary",
    NOT_DELETED_PRIMARY: "Cannot delete primary card",
    FAILED: "Failed",
    EMAIL_ALREADY_EXIST: "Email address already exists",
    EMAIL_REQUIRED: "Email is required",
    INVALID_EMAIL: "Email is invalid",
    INVALID_PROMOCODE: "Invalid Promocode",
    EMAIL_CAN_NOT_EMPTY: "Email can not be empty!",
    EMAIL_ADDRESS_CAN_NOT_EMPTY: "Email address can not be empty",
    PROMOCODE_LINK_COPIED: "Promocode has been copied successfully",
    SELECT_EXP_DATE: "Please select an expiry date greater than start date",
    TRANSACTION_VALIDATION:
        "Transaction sell rate should be greater than transaction buy rate.",
    IMPLEMENTATION_VALIDATION:
        "Implementation sell rate should be greater than implementation buy rate.",
    DESCRIPTION_SIZE: "Characters should be less 85",
    CHOOSE_PARTNER: "Please Check Atleast One Checkbox",
    LOGO_SIZE: "File size must be less than 1 mb",
    REMARKS_MISSING: "Please enter remarks",
    ADD_SUBJECT_ERROR: "Please add subject",
    SELECT_STATE: "Please select state",
    SELECT_COMPANY: "Please select partner company",
    VALID_STATE: "Please enter valid state",
    NO_RESULT_FOUND: "No results found.",
    ENROLLMENT_COMPLETED: "Enrollment has been completed",
    SERVICE_AGREEMENT: "Please agree to the Terms of Service Agreement",
    PERSONAL_MPOC_EMAIL_CAN_NOT_SAME:
        "Personal and main point contact email cannot be same",
    FILE_SIZE_TOO_LARGE: "File size too large",
    FILE_NOT_ACCEPTED: "File not accepted",
    DRAG_DROP_FILE_HERE: "Drag and Drop file here OR Click to select file",
    UPLOAD_FILE: "Upload only jpg & pdf file",
    CAPTCHA: "Captcha did not match",
    ENTER_QUS: "Please enter question",
    ENTER_ANS: "Please enter answer",
    AT_LEAST_ONE_OPTION: "Please select at least one option",
    SELECTED_PREFERENCE: "Please select at least preference",
    VIDEO_SIZE: "Video size must be less than 50 mb",
    VIDEO_PROCESS: "Video upload is in processing",
    SELECT_ENDUSER: "Please select an end user",
    SELECT_PARTNER: "Please select a partner",
    SELECT_BRANCH: "Please select a branch",
    SELECT_LOAN_ORGINATOR: "Please select a loan originator",
    NO_CHILD_PRESENT: "No Current Child Present",
    EMAIL_SUBJECT: "Email subject can not empty ",
    CANCEL_SCHEDULE_ALERTS: "Scheduled alerts response cancelled successfully",
    UNSUBSCRIBED_EMAIL: "Contact(s) has unsubscribed from emails",
    UNSUBSCRIBED_SMS: "Contact(s) has unsubscribed from sms",

    ERROR_CANCEL_SCHEDULE_ALERTS:
        "Error occured while canceling scheduled alerts.Please try again.",
    CUSTOM_FIELD: "Please select custom field template",
    SELECT_CUSTOM_FIELD: "Please select type of trigger email",
    ACCEPT_TERMS_CONDITION: "Please accept the terms and conditions",
    CANNOT_DELETE_LEADS: "Cannot delete loan officer's clients",
    PERMISSION_DENIED: "Permission Denied",
    UPDATE_INFO: "Missing Fields,Please update your information",
    CANNOT_UNSUBSCRIBE_CONTACT:
        "Currently you cannot unsubscribe for Contact service.",
    LINK_EXPIRED: "Promocode has been Expired",
    LINK_NOT_ACTIVATED: "Promocode is not activated yet",
    //ADD_ROLE: "Please add role",
    SUBSCRIBE_CONTACT: "Please subscribe to Contact service",
    AREACODE_MISSING: "Please enter the area code",
    TRANSFER_NUM_MISSING: "Please enter the number for live transfer",
    SMS_TEMPLATE_LENGTH: "you cannot add more than 255 character",
    APIKEY_REQUIRED: "Apikey cannot be empty",
    EMAIL_ID_INACTIVE: "Email Id does't exists",
    BOMBBOMB_APIKEY_REQUIRED: "Please provide Apikey from bombbomb to use video services",
    VIDEO_REQUIRED: "Please record a video to save",
    VIDEO_SAVED: "Video Saved Successfully",
    COLUMN_REQUIRED: "Please select all needed data",
    STATUS_CHANGE: "Client has been deleted, cannot change status.",
    CHOOSE_SEQUENCE: "Please choose a campaign template to proceed.",
    FILL_NAME: "Please enter campaign name to proceed.",
    CREATE_STEP: "Please create atleast one step to proceed.",
    STEP_TEMPLATE: "Please select template for this step.",
    AFTER_STEP_ERROR:
        "Please choose after steps for all the steps except the initial step to proceed.",
    CANNOT_DELETE_ADMIN_SEQUENCE: "Campaign added by admin cannot be deleted.",
    SET_INTERVAL: "Please enter either day,hour or minute in interval section.",
    DUPLICATE_STEP: "This step name already exists.",
    FILL_ALL_FIELDS: "Please fill all fields",
    TIME_FRAME_DUPLICATE: "Please select different date and  timeframe",
    DISABLE_SEQUENCE: "Campaign cannot be sent for un-monitored.",
    ADMIN_SEQUENCE_NAME:
        "Campaign name can not be same as admin campaign,please rename.",
    NO_CONTACT:
        "Campaign cannot be scheduled, as email and mobile number doesn't exist for this borrower",
    LEAD_CONTACT_BLANK: "Contact(s) does not have mobile number",
    LEAD_EMAIL_BLANK: "Emails are either invalid or does not exist",

    LEAD_DOB_BLANK: "Contact(s) does not have DOB",
    LEAD_CLOSING_DATE_BLANK: "Contact(s) does not have closing date",
    REFERRAL_PARTNER_CLOSING_DATE_BLANK:
        "Un-Monitored does not have closing date",
    REFERRAL_PARTNER_CONTACT_BLANK: "Un-Monitored does not have mobile number",
    REFERRAL_PARTNER_EMAIL_BLANK: "Un-Monitored does not have email id",
    REFERRAL_PARTNER_DOB_BLANK: "Un-Monitored does not have DOB",
    SAVE_STEP: "Please save your step's changes to proceed.",
    SEQUENCE_HOUR_VALIDATION: "Enter in range of 1 to 23",
    SEQUENCE_MINUTE_VALIDATION: "Enter in range of 1 to 59",
    INVALID_TIME:
        "Current step's time cannot be before execute after step's time.",
    NO_DEFAULT_STEP: "Please create a default step to proceed.",
    INTERVAL_ERROR:
        "Please enter interval for all the steps except the initial step to proceed.",
    INCORRECT_DATA: "These Contact(s) data are incorrect",
    DUPLICATE_IN_SHEET: "These Contact(s) data are duplicate in sheet",
    DUPLICATE_IN_SYSTEM: "These Contact(s) data are duplicate in system",
    DUPLICATE_IN_SAME_DATABASE: "These Contact(s) data are duplicate in database",
    PASSWORD_COPIED: "Generated password has been copied successfully.",
    PASSWORD_NOT_MATCHED: "Password and confirm password does not match",
    PASSWORD_MATCH_ERROR: "New password and confirm new password do not match.",
    CANNOT_DELETE_ALL_ROWS: "you can't delete all the rows on the table",
    SELECT_TEMPLATE: "Please Select Template",
    LEAD_DB_UPLOAD: "Database has been uploaded successfully",
    AUTO_ALERT_NAME_ERROR:
        "General And Auto Alert Response Template Name Can Not Be Same",
    DATA_UNDER_PROCESS: "Please correct your data, it is under process.",
    EMPTY_DATABASE_FILE: "File has no data,Please fill and uplaod again",
    ENABLE_SEND_ALL_SEQUENCE: "Please select Send All option to proceed.",
    DEFAULT_SEQUENCE:
        "Please create a default campaign from templates, to proceed.",
    DEFAULT_TRIGGER_EMAIL:
        "Please create a default Trigger Email from templates, to proceed.",
    DEFAULT_TRIGGER_SMS:
        "Please create a default Trigger SMS from templates, to proceed.",
    DOB_CLOSINGDATE_SELECT: "Please select DOB or closing date to proceed.",
    DEFAULT_SEQUENCE:
        "Please create a default campaign from templates, to proceed.",
    DEFAULT_TRIGGER_DOB: "Please select Trigger DOB  template.",
    DEFAULT_TRIGGER_CLOSING: "Please select Trigger Closing  template.",
    DEFAULT_TRIGGER_SMS:
        "Please create a default Trigger SMS from templates, to proceed.",
    DOB_NOT_SELECT: "Please select DOB checkbox.",
    CLOSING_DATE_NOT_SELECT: "Please select closing date checkbox",
    CANNOT_SET_SEQUENCE:
        "Please disable the Auto Alert Email and Auto Alert SMS to proceed.",
    CANNOT_SET_AUTO_EMAIL_SMS:
        "Please disable the Auto Alert Campaign to proceed.",
    GENERAL_TEMPLATE_EXIST: "General template name already exist",
    AUTO_ALERT_RESP_TEMPLATE_EXIST:
        "Auto Alert Response template name already exist",
    DOB_TEMPLATE_EXIST: "DOB template name already exist",
    CLOSING_DATE_TEMPLATE_EXIST: "Closing Date template name already exist",
    DOB_CLOSING_SELECT: "Select DOB or Closing Date checkbox or Both",
    SELECT_TYPE: "Please select template type",
    DISCARD_SETTING_TRIGGER:
        "Email scheduled from settings has been discarded successfully",
    DISCARD_SETTING_TRIGGER_SMS:
        "SMS scheduled from settings has been discarded successfully",
    DISCARD_ENGAGE_TRIGGER:
        "Email scheduled from Marketing Communications has been discarded successfully",
    DISCARD_ENGAGE_TRIGGER_SMS:
        "SMS scheduled from Marketing Communications has been discarded successfully",
    BORROWER_REFERRAL_MOBILE_DNE:
        "Borrower/Un-Monitored does not have mobile no.",
    BORROWER_REFERRAL_EMAIL_DNE: "Borrower/Un-Monitored  does not have email",
    ADMIN_UNMONITORED_TYPE_NOT_DELETE: "Admin unmonitored type can not be delete",
    ADMIN_UNMONITORED_TYPE_NOT_EDIT: "Admin unmonitored type can not be edit",
    EXIST_UNMONITORED_ID: "Un-Monitored type already exists",
    EMPTY_UNMONITORED_TYPE: "Un-Monitored type content cannot be empty",
    SELECT_UNMONITORED_TYPE: "Please select Un-Monitored type",
    CHARACTERS_LESS_THEN_50: "Characters should be less 50",
    ADDRESS_AND_ZIPCODE_REQUIRED:
        "First Name, Last Name, Address and zip-code is required to push to reconnect",
    API_TOKEN_EMPTY: "API token Cannot be empty",
    STOP_CREATE_CONTACT_ATNORTH_TEXT:
        "Contacts will no longer be created on NorthText",
    SIGNATURE_NAME: "Please enter signature name",
    SIGNATURE_CONTENT: "Please enter signature content",
    PLEASE_WAIT: "Please wait,Database is being processed",
    PLEASE_SELECT_DATE: "Please select Date or Time",
    POST_URL_EMPTY: "Posting URL can not be empty",
    AUTO_SNOOZE_CHECKBOX_CHECK: "Please select auto snooze checkbox",
    AUTO_SNOOZE_DAYS: "Please enter auto snooze days",
    SNOOZE_DAYS_GREATER_THEN_ZERO: "Snooze days should be greater then zero",
    SOURCE_ID_EMPTY: "SourceId can not be empty",
    MAPPING_ID_EMPTY: "MappingId can not be empty",
    DISCARD_MESSAGE: "Database discarded successfully",
    STOP_SEQUENCE: "Campaign stop successfully",
    PUBLIC_TEMPLATE_CANT_DELETE: "Public template can not be deleted",
    PUBLIC_SEQUENCE_CANT_DELETE: "Public campaign can not be deleted",
    ENTER_CUSTOM_FIELD_NAME: "Please enter custom field name",
    ENTER_ATTRIBUTE_NAME: "Please enter  attribute name",
    SELECT_CUSTOM_FIELD_TYPE: "Please select custom field type",
    SELECT_ATTRIBUTE_TYPE: "Please select attribute type",
    DUPLICATE_ILINK_ATTRIBUTE: "Attribute name already exists",
    CUSTOM_FIELD_ADDED: "Custom field added successfully",
    CUSTOM_FIELD_ADD_IN_EMAIL:
        "Custom fields will be added to alert distribution email",
    CUSTOM_FIELD_NOT_ADD_IN_EMAIL:
        "Custom fields will not be added to alert distribution email",
    CUSTOM_FIELD_ADD_IN_SMS:
        "Custom fields will be added to alert distribution SMS",
    CUSTOM_FIELD_NOT_ADD_IN_SMS:
        "Custom fields will not be added to alert distribution SMS",
    CUSTOM_FIELD_EXIST: "Custom Fields Already Exist",
    CUSTOM_NAME_EXIST: "Custom Field Name Already Exist",
    ENABLE_ALERT_DISTRIBUTION_SMS: "Please Enable alert distribution SMS",
    STOP_SEQUENCE_FIRST: "please stop campaign first",
    CANT_DELETE_SEQUENCE_STEP:
        "Campaign is in pending state,step cannot be deleted.",
    CANT_ADD_SEQUENCE_STEP: "Campaign is in pending state,step cannot be added.",
    CANT_EDIT_SEQUENCE_STEP: "Campaign is in pending state,step cannot be edit.",
    CANT_EDIT_DELETE_SEQUENCE_STEP:
        "Campaign is already scheduled, if you want to delete or edit it please delete it from Marketing Communications first",
    FILLED_PAUSE_DAYS: "Please enter pause days",
    SES_REGION_VALIDATE: "Please choose a different region than what is currently selected",
    EMAIL_TRACKING_FOR_SEQUENCE: "Please check Email Behavior Monitoring to yes",
    EMAIL_TRACKING_PREFERENCE:
        "Preference for Email Behavior Monitoring updated successfully",
    INTEGRATION_SUBSCRIBE: "Intergration subscribed successfully",
    FIELDS_REQUIRED: "Fields cannot be empty",
    API_UPDATED_SUCCESS: "API key successfully updated",
    ALERT_EDIT: 'Alert has been updated successfully',
    ALERT_ADD: 'Alert has been added successfully',
    PRODUCT_SELECT: "Please select the plan",
    PRODUCT_SUBSCRIPTION: "Please select a Subscription of Product",
    ALl_ALERTS_SELECTED: "Default template is already selected for all alert types",
    DELETE_SELECTED_CANT_DELETE: "Alert Type is set on the template",
    DATA_BASE_USE_INFROMATION: "This Database is in already Use",
    SELECT_ALERT_TYPE: "Select alert type",
    SELECT_DB_OR_LEADS: 'Please select database or Contacts',
    SELECT_LEADS: 'Please select Database',
    LEAD_NOT_EXIST: 'This Contact does not exist',
    DOWNLOAD_PROCESSSING: "Please wait, download is being processed",
    SELECT_DATABASE: 'Please Select database',
    COMMUNICATION_ADDED: 'Communication added successfully',
    EDIT_CUSTOM_FIELDS: 'Custom Field has been edited successfully',
    SELECT_ALTAIR_TYPE: "Please Select Type",
    SELECT_EVENT_TYPE: "Please Select Web Browsing Category",
    SELECT_CITY: "Please Select City",
    SELECT_ADVANCE_FILTER: "Please select advance filter attribute first",
    ALREADY_ADDED_INTEGRATION: "You have already added for this integration",
    GROUP_NAME_REQUIRED: "Please enter distribution group name",
    EMAIL_PREFERENCE_UPDATED: "Email preference has been updated successfully",
    SMS_PREFERENCE_UPDATED: "Sms preference has been updated successfully",
    DELETE_ALERT_MESSAGE: "Alert has been deleted successfully",
    DELETE_FAQ_MESSAGE: "FAQ has been deleted successfully",
    DELETE_DOCUMENT_MESSAGE: "Document has been deleted successfully",
    DATABASE_UPDATED: "Database Updated Successfully",
    PROMOCODE_NOT_EXIST: "Promo Code does not exist",
    PROMOCODE_APPLIED: "Promo code has been applied",
    SELECT_ATTRIBUTE: "Please select distribution attribute first",
    SELECT_GROUP_NAME: 'Please enter group name first',
    ALERT_NAME_EXIST: 'Alert name is already exist',
    GROUP_NAME_EXIST: 'Group name is already exist',
    PLEASE_SELECT_ALERT_TYPE: "Please select atleast one Alert Type",
    PLEASE_UPDATE_BUDGET: "Please Update budget preference",
    NOT_SET_BUDGET: "Please enter your budget to proceed",
    PLEASE_UPDATE_BUDGET_VALUE: "Before updating all the changes, please make sure to save any modifications you made to the amount in step 4.",
    SEQUENCE_PAST_TIME_CHOSEN: "Campaign can only be scheduled ahead of current time.",
    EMAIL_PAST_TIME_CHOSEN: "Email can only be scheduled ahead of current time.",
    SMS_PAST_TIME_CHOSEN: "SMS can only be scheduled ahead of current time.",

    STATE_VALIDATION_WARNING: "Please select atleast one state",
    DATABASE_LINKING: "Please Link database",
    CHANGE_REQUIRED: "Please update the value",
    SELECT_TEMPLATE: "Please Select Template",
    PREFERENCE_VALIDATION: "Please select atleast one preference",
    SELECT_TYPE: 'Please select type from Step-1',
    SELECT_ALERT_NAME: "Please Select Alert Name",
    ADD_COMMUNICATION: "Please Add Communication",
    ADD_ATTRIBUTE_CONDITION: "Please Save Your Attributes Conditions",
    ADD_UNIQUE_CONDITION: "Please Specify Unique Conditions",
    SPECIFY_CONDITION: "Please Specify Conditions",
    ERROR_AFTER_HOUR: "Please try after one hour",
    SELECT_PARTNER_TYPE: "Please select Partner Company",
    ALREADY_SUBSCRIBED: "You can't choose your current plan",
    SELECT_AT_LEAST_ONE_PREFERENCE: 'Please add preference first',
    TO_WITH_CC_BCC: "To field is required when Cc or Bcc is provided.",
    SAVE_GROUP_VALIDATION: 'Please save group first',
    DATABASE_CREATE: "Please create Database First",
    CANCEL_PREVIOUSE_TRIGGER_COMMUNICATION: 'Please cancel your previous trigger communication',
    DATABASE_EMPTY: "Database(s) is empty",
    DATABASE_DELETED: "Database is deleted",
    PLEASE_SELECT_SEQUENCE_TEMPLATE: 'Please select Campaign Template',
    Please_SELECT_EMAIL_TEMPLATE: 'Please select Email Template',
    ZIPCODE_ADDRESS_EMPTY: "Please update ZipCode and Address of Contacts in selected database",
    PLEASE_SELECT_DATABASE_link: 'Please link database first',
    ALERT_ARE_PRESENT: 'Alert already exists with the same database(s).',
    DESCRIPTION_SIZE_MESSAGE: 'Please enter a maximum of 200 characters.',
    UPGRADE_TO_BI: 'Requires minimum Stikkum plan subscription',
    DOUBLE_QUOTES_NOT_ALLOW: 'Double quotes symbol ( " ) not allowed',
    REMOVED_DUPLICATE_TAG: 'Tags that are duplicate have been eliminated.',
    TAG_DELETED: 'Tag deleted successfully; changes will be saved after clicking the "Save" button.',
    TAG_LIST_UPDATED: 'Tag list updated successfully',
    TAG_ADDED_SUCCESSFULLY: "Tag(s) have been successfully added.",
    TAG_DELETED_SUCCESSFULLY: "Tag have been successfully Deleted.",
    TAG_VISIBILITY_CHANGED: "Tag have been updated successfully.",
    TAG_NAME_CANT_BE_EMPTY: "Tag name can't be empty",
    INVALID_TAG: ' is not a valid tag',
    DUPICAATE_TAG: "Tag can't be duplicate",
    PLEASE_ENTER_TAGS: 'Please enter tag(s)',
    NO_CHANGES_IN_TAG_LIST: 'No changes to update tag list',
    ADD_TAG_FIRST: "Please add tag(s) and then save it.",
    DOUBLE_QUOTES_NOT_ALLOW: 'Double quotes symbol ( " ) not allowed',
    NO_ATTRIBUTES_ILINK: "There are no attributes",
    NOT_ALLOWED: `You can only display a maximum of three videos in the "Featured Videos" section.`,
    INVALID_URL: `Invalid URL! Please use a URL starting with http:// or https://.`,

    FILE_DOWNLOADED: "File downloaded successfully",
    PLEASE_SELECT_FILE: 'Please select a file to upload.',
    VIDEO_DELETED: 'Video has been deleted successfully',
    PRICE_UPDATED: 'Price has been updated successfully',
    ERROR_LOADING_TEMPLATES: 'FAILED TO LOAD TEMPLATES',

    FILL_PERSONAL_INFO_FIELD: "Please complete your personal and company information before proceeding.",
    PLEASE_ENTER_PROMO: 'Please Enter Promo Code',
    SOMETHING_WRONG: "Something went wrong",
    FIRST_OR_LAST_NAME_CAN_NOT_EMPTY: "First Name or Last name cant't be empty",
    MUST_FILLED: "At least one field must be filled!",
    CITIES_FAILED: 'Failed to load cities',
    PARTNERSHIP_DISCONTINUED: 'Partnership has been discontinued successfully',
    LINK_ALREADY_EXISTS: 'Landing Page Link already exists',
    MEDIA_PERMISSION_DENIED: "Camera or Microphone not found / permission denied",
    VERIFY_DATABASE: "Please wait, verifying the database.",
    SELECT_AT_LEAST_ONE_DATABASE: "Please select at least one database",
    DISCARD_FILE: "Discard File Successfully",
    PLEASE_CREATE_ALERT_BEHAVIOUR_MONITORING: "Please create a alert in Monitor and Alerts",
    DATA_TOO_LARGE: "The data exceeds the allowed limit for export. Please contact the administrator.",
    SUCCESS_SEND_VERSE: "Contact(s) sent to Verse successfully",
    PARTNER_ADDED_SUCCESS: "Partner added successfully",
    PARTNER_UPDATED_SUCCESS: "Partner updated successfully",
    VIDEO_DRAGGED_SUCCESS: "Video dragged successfully",





    //& Validation Messages . . . !!!
    MINIMUM_CREDIT_SCORE: "Please enter minimum credit score",
    MINIMUM_CREDIT_CARD_BALANCE: "Please enter minimum credit card balance",
    MAXIMUM_CREDIT_CARD_BALANCE: "Please enter maximum credit card balance",
    MINIMUM_REVOLVING_DEBT_BALANCE: "Please enter minimum revolving debt balance",
    REQUIRED_CLTV: "Please provide CLTV.",
    REQUIRED_REVOLVING_UTILIZATION_INCREASE: "Provide Total Revolving Debt Utilization Monitor Increase",
    MIN_CREDIT_SCORE: "Credit score must be at least 300",
    MAX_CREDIT_SCORE: "Credit score cannot exceed 850",
    MIN_PERCENTAGE: "Please enter a valid minimum percentage.",
    MAX_PERCENTAGE: "Please enter a valid maximum percentage.",
    NOT_GREATER_THEN_FROM: "Minimum value cannot be greater than Maximum value",
    NOT_GREATER_THEN_TO: "Maximum value cannot be less than Minimum value",
    ENTER_MAX_CREDIT_SCORE: "Please enter maximum credit score",

    EXPIRED_CAMPAIGN_DATE: "One or more campaign dates have already expired.",
    MINIUM_REVOLVING_UTILIZATION: "Please provide minimum revolving utilization",
    MAXIMUM_REVOLVING_UTILIZATION: "Please provide maximum revolving utilization",

};

export default MESSAGE;